import styled from 'styled-components';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 300px;
`;

export const CategoryOptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    width: 95%;
    margin-top: 20px;
`;

export const CategoryDataContainer = styled.div`
    text-align: left;
    max-width: 40vw;
`;

export const CategoryContainerRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: ${props => props.cursor ?? ''};
`;

export const CategoryDataTitle = styled.h4``;

export const CategoryDataText = styled.p`
    margin-left: 5px;
`;